import React from 'react';
import { LegalDocument } from '../../components/sections/LegalDocument';
import { PageHero } from '../../components/ui/PageHero';
import { privacySections } from '../../data/legal';
import { usePageMeta } from '../../hooks/usePageMeta';
export function Privacy() {
  usePageMeta('Privacy Policy', 'How Aurevane Search Partners collects, uses, and protects personal information submitted by employers and candidates.');
  return <>
      <PageHero compact label="Legal" title="Privacy Policy" intro="How we handle the information you share with us." data-id="element-905" data-mp="10qckpyz8twwt" />
      <LegalDocument sections={privacySections} data-id="element-906" data-mp="vq82o4iosu4h" />
    </>;
}